export const LIST_MAIL_REQUEST = [
  { key: 'Any', value: '全て' },
  // { key: 'Any', value: 'いずれか' },
  { key: 'BookingCertificate', value: '利用証' },
  { key: 'FacilityGuide', value: '施設案内資料' },
  { key: 'PointCertificate', value: 'ポイント残高' },
  { key: 'Ads', value: 'チラシ等' }
]
